export default "__VITE_ASSET__BgdgRZKD__"